import axiosClient from './axiosClient';
import { urlApiCustomer } from '~/utils/constants/apis';
import {
  ICustomer,
  ICustomerDetail,
  IExportCustomerFileRes,
  IParamScheduleForCustomerDetail,
  IPayloadEditCustomer,
} from '~/utils/interface/customer';
import { IBaseDeleteBody, IQueryParamBase } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { ISchedule, IScheduleTimeLine } from '~/utils/interface/schedule';

const customerApi = {
  getCustomerList: (params: IQueryParamBase) => {
    const url = urlApiCustomer.getCustomerList;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICustomer[]>>>(url, { params });
  },

  createCustomer: (formData: FormData) => {
    const url = urlApiCustomer.createCustomer;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  editCustomer: (payload: IPayloadEditCustomer) => {
    const { customerId, body } = payload;
    const url = urlApiCustomer.editCustomer(customerId);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  getCustomerDetail: (id: string) => {
    const url = urlApiCustomer.getCustomerDetail(id);
    return axiosClient.get<IBaseResponse<ICustomerDetail>>(url);
  },

  importCustomer: (formData: FormData) => {
    const url = urlApiCustomer.importCustomer;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  exportCustomer: (params: IQueryParamBase) => {
    const url = urlApiCustomer.exportCustomer;
    return axiosClient.get<IBaseResponse<IExportCustomerFileRes>>(url, { params });
  },

  sendToQuickBooks: (customerId: string) => {
    const url = urlApiCustomer.sendToQuickBooks(customerId);
    return axiosClient.put<IBaseResponse>(url);
  },

  getScheduleList(payload: IParamScheduleForCustomerDetail) {
    const url = urlApiCustomer.getListSchedule(payload.customerId);
    return axiosClient.get<IBaseResponse<ISchedule[] | IScheduleTimeLine[]>>(url, {
      params: payload.params,
    });
  },

  deleteCustomer: (params: IBaseDeleteBody) => {
    const url = urlApiCustomer.deleteCustomer;
    return axiosClient.delete<IBaseResponse>(url, { params });
  },
};

export default customerApi;
